import { OpnPlatformType } from '@sageworks/core-logic/src/enums';
import { Formio } from 'formiojs';

export const getBestPracticeProjectUrl = (platformType: OpnPlatformType, inSandbox: boolean) => {
	const bestPracticeProject = platformType === OpnPlatformType.CommunityLending ? 'abrigocommunitylending' : 'bestpractice';
	const projectName = `${bestPracticeProject}${inSandbox ? '-sandbox' : ''}`;

	return `${Formio.getBaseUrl()}/${projectName}`;
};